import React, { useContext, useEffect, useState } from "react";
import { HiOutlinePlusSm } from "react-icons/hi";
import VTradingContext from "../../context/vTrading/VTradingContext";
import VtradingScreen2 from "./VtradingScreen2";
import DummyVtradingScreen2 from "./DummyVtradingScreen2";
import ParameterContext from "../../context/parameter/parameterContext";
import NumberFormat from "react-number-format";
import { formatPrice } from "../../helpers/format";
import { IoWallet } from "react-icons/io5";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";

import cryptoContext from "../../context/crypto/cryptoContext";
import {  AiFillEdit } from "react-icons/ai";
import { BsChevronDown, BsFillLockFill } from "react-icons/bs";

import ReactTooltip from "react-tooltip";
import { TiTick } from "react-icons/ti";
import authContext from "../../context/auth/authContext";
import axios from "axios";
import dotenv from "dotenv";
import VtradingPagination from "../../components/VtradingPagination";

import { toast } from "react-toastify";

import Swal from "sweetalert2";
import PayForPortfolio from "../../components/PayForPortfolio";
dotenv.config();
const Vtrading = ({ history }) => {
  const {
    singlePortfolio,
    getCoinsInParticularPortfolioInVt,
    
    invAmount,
    currentAmount,
    netPL,
    setAlreadyInvested,
    vTradingModal,
    toggleVtradingModal,
    setTotalInvAmount,
    setTotalCurrentAmount,
    setTotalNetPL,
    
    vTradingLoading,
    alreadyInvested,
    buyNewPortfolio,
    position,
    portId,
    historyOrders,
    openOrders,
  } = useContext(VTradingContext);
  const { setVtButton, vtButton, setActivePortfolioPage, activePortfolio } =
    useContext(ParameterContext);
  const { livePriceData, cryptoData, exchangeRate, currencySymbol} =
    useContext(cryptoContext);
  const { userData, editPortfolioName, walletData, getAmountInWallet } =
    useContext(authContext);
  const [paymentLoading, setPaymentLoading] = useState(false);
  useEffect(() => {
    getAmountInWallet();
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (vTradingModal) {
      toggleVtradingModal();
    }
    setAlreadyInvested();
    setEditPName(false);
    //eslint-disable-next-line
  }, [userData]);
  useEffect(() => {
    // clearCoinsData();
    if (activePortfolio <= userData?.VirtualPortfolio?.length)
      getCoinsInParticularPortfolioInVt(1);
    else {
      getCoinsInParticularPortfolioInVt(2);
    }
    //eslint-disable-next-line
  }, [activePortfolio, vtButton, alreadyInvested]);
  useEffect(() => {
    setVtButton("position");
    //eslint-disable-next-line
  }, [activePortfolio]);
  useEffect(() => {
    if (!position || !position?.length > 0) {
      setTotalInvAmount(0);
      setTotalCurrentAmount(0);
      setTotalNetPL(0);
    }
    //eslint-disable-next-line
  }, [position]);
  const handleEdit = () => {
    setEditPName(!editPName);

    toast.error("Please Edit Portfolio Name to Save", {
      position: "top-right",
      autoClose: 6000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const port = singlePortfolio?.data[0];
  const [openDropdown, setOpenDropdown] = useState(false);
  const [editPName, setEditPName] = useState(false);
  const [PName, setPName] = useState(
    userData.VirtualPortfolio && userData.VirtualPortfolio[activePortfolio - 1]
      ? userData.VirtualPortfolio[activePortfolio - 1].portName
      : `Portfolio-${activePortfolio}`
  );
  let portName =
    userData.VirtualPortfolio &&
    userData.VirtualPortfolio[activePortfolio - 1] &&
    userData.VirtualPortfolio[activePortfolio - 1].portName;
  useEffect(() => {
    setPName(portName);
    //eslint-disable-next-line
  }, [activePortfolio]);
  const [modal,setModal]=useState(false)
const closeModal=()=>{
setModal(false);
}
const showModal=()=>{
  setModal(true);
  
}

  return (
    <div className="Vtrading">
      <div className="Vtrading__container">
        {modal&&<PayForPortfolio close={closeModal}/>}
        <center>
          <h2>Virtual Investment on Real Cryptos</h2>
        </center>
        {vTradingLoading || !livePriceData ? (
          <div className="Vtrading__section__container">
            <div
              className="Vtrading__section1"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <h3>Statistics</h3>
              <div className="horizontal__line"></div>
              <div className="statistics__container">
                <div className="skeleton text" style={{ width: "200px" }} />

                <div className="skeleton text" style={{ width: "200px" }} />

                <div className="skeleton text" style={{ width: "200px" }} />
              </div>
              <div className="shimmer-wrapper">
                <div className="shimmer"></div>
              </div>
            </div>
            <div
              className="Vtrading__section3"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <div>
                <h2 style={{ display: "flex", alignItems: "flex-end" }}>
                  <IoWallet size={25} style={{ marginRight: "15px" }} />
                  <span>Portfolio Value</span>
                </h2>

                <div
                  className="skeleton text"
                  style={{ width: "200px", height: "40px", marginTop: "25px" }}
                />
              </div>
              <div className="shimmer-wrapper">
                <div className="shimmer"></div>
              </div>
            </div>
            <div
              className="Vtrading__section2"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <h2>Available Balance</h2>

              <div
                className="skeleton text"
                style={{
                  width: "200px",
                  height: "40px",
                  margin: "auto",
                  marginTop: "25px",
                }}
              />

              <div
                className="skeleton text"
                style={{
                  width: "200px",
                  height: "12px",
                  margin: "auto",
                  marginTop: "5px",
                }}
              />

              <div className="shimmer-wrapper">
                <div className="shimmer"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="Vtrading__section__container">
            <div
              className="Vtrading__section1"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <h3>Statistics</h3>
              <div className="horizontal__line"></div>
              <div className="statistics__container">
                {vTradingLoading || !cryptoData || !cryptoData.length > 0 ? (
                  <div className="skeleton text" style={{ width: "200px" }} />
                ) : (
                  <p>
                    Invested :
                    {singlePortfolio
                      ? invAmount && (
                          <NumberFormat
                            value={formatPrice(invAmount / exchangeRate)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={currencySymbol}
                          />
                        )
                      : "NA"}
                  </p>
                )}
                {vTradingLoading || !cryptoData || !cryptoData.length > 0 ? (
                  <div className="skeleton text" style={{ width: "200px" }} />
                ) : (
                  <p>
                    Current :
                    {singlePortfolio
                      ? currentAmount && (
                          <NumberFormat
                            value={formatPrice(currentAmount / exchangeRate)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={currencySymbol}
                          />
                        )
                      : "NA"}
                  </p>
                )}
                {vTradingLoading || !cryptoData || !cryptoData.length > 0 ? (
                  <div className="skeleton text" style={{ width: "200px" }} />
                ) : (
                  <p>
                    Net P&L :
                    {singlePortfolio ? (
                      netPL ? (
                        <NumberFormat
                          value={formatPrice(
                            (currentAmount - invAmount) / exchangeRate
                          )}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={
                            netPL > 0
                              ? `+${currencySymbol}`
                              : `${currencySymbol}`
                          }
                        />
                      ) : (
                        <>0</>
                      )
                    ) : (
                      "NA"
                    )}
                    (
                    <span
                      style={{
                        color:
                          netPL < 0
                            ? "rgba(233, 56, 72, 1)"
                            : "rgba(69, 170, 67, 1)",
                      }}
                    >
                      {singlePortfolio
                        ? netPL &&
                          invAmount && (
                            <NumberFormat
                              value={
                                netPL &&
                                invAmount &&
                                formatPrice((Math.abs(netPL) / invAmount) * 100)
                              }
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={(netPL / invAmount) * 100 < 0 ? "-" : "+"}
                              suffix={"%"}
                            />
                          )
                        : "NA"}
                    </span>
                    )
                  </p>
                )}
              </div>
              <div className="shimmer-wrapper">
                <div className="shimmer"></div>
              </div>
            </div>
            <div
              className="Vtrading__section3"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <div>
                <h2 style={{ display: "flex", alignItems: "flex-end" }}>
                  <IoWallet size={25} style={{ marginRight: "15px" }} />
                  <span>Portfolio Value</span>
                </h2>
                {vTradingLoading || !cryptoData || !cryptoData.length > 0 ? (
                  <div
                    className="skeleton text"
                    style={{
                      width: "200px",
                      height: "40px",
                      marginTop: "25px",
                    }}
                  />
                ) : singlePortfolio ? (
                  <h1>{`${formatPrice(
                    ((isNaN(port.curramount) ? 0 : port.curramount) +
                      currentAmount) /
                      exchangeRate
                  )} CST`}</h1>
                ) : (
                  <h1>NA</h1>
                )}
              </div>
              <div className="shimmer-wrapper">
                <div className="shimmer"></div>
              </div>
            </div>
            <div
              className="Vtrading__section2"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <h2>Available Balance</h2>
              {vTradingLoading || !cryptoData || !cryptoData.length > 0 ? (
                <div
                  className="skeleton text"
                  style={{ width: "200px", height: "40px", marginTop: "25px" }}
                />
              ) : singlePortfolio ? (
                <h1>
                  {formatPrice(
                    port.curramount / exchangeRate -
                      port.lockamount / exchangeRate
                  )}
                  CST
                </h1>
              ) : (
                <h1>NA</h1>
              )}
              {vTradingLoading || !cryptoData || !cryptoData.length > 0 ? (
                <div
                  className="skeleton text"
                  style={{ width: "200px", height: "12px", marginTop: "5px" }}
                />
              ) : (
                singlePortfolio && (
                  <p>
                    {port.lockamount === 0 ? (
                      <br />
                    ) : (
                      `Lock Amount:${formatPrice(
                        port.lockamount / exchangeRate
                      )}`
                    )}
                  </p>
                )
              )}
              {vTradingLoading || !cryptoData || !cryptoData.length > 0 ? (
                <div className="shimmer-wrapper">
                  <div className="shimmer"></div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        )}
        {singlePortfolio ? (
          <div className="portfolio__container">
            {editPName ? (
              <input
                style={{ fontSize: "24px", width: "200px" }}
                type="text"
                value={PName}
                onChange={(e) => setPName(e.target.value)}
              />
            ) : (
              // <input   style={{ fontSize: "24px", width: "200px" }} type="text" value={PName} disabled/>
              <p style={{ fontSize: "24px" }}>{PName}</p>
            )}
            <div className="portfolioName__edit">
              {editPName ? (
                <>
                  <TiTick
                    data-tip="Save Portfolio Name"
                    style={{ cursor: "pointer", color: "#fff" }}
                    size={30}
                    onClick={() => {
                      PName === portName
                        ? handleEdit()
                        : PName.length <= 16
                        ? editPortfolioName(PName, portId)
                        : toast.error(
                            "Portfolio Name Edit unsuccessful, length cannot be greater than 16",
                            {
                              position: "top-right",
                              autoClose: 6000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                            }
                          );
                    }}
                  />
                  <ReactTooltip place="right" effect="float" />
                </>
              ) : (
                <AiFillEdit
                  data-tip="Edit Portfolio Name"
                  style={{ cursor: "pointer" }}
                  onClick={() => setEditPName(!editPName)}
                />
              )}
              <ReactTooltip place="right" effect="float" />
            </div>
          </div>
        ) : (
          <div style={{ marginTop: "99px" }}></div>
        )}
        <div
          className="VtradingScreen2__investment__page__container"
          style={{
            justifyContent: "space-between",
          }}
        >
          <button
            className="TradathonRoom__button"
            style={{
              margin: 0,
              width: "150px",
            }}
            onClick={() => history.push("/vtrading/screen")}
          >
            + <span>Add More Coins</span>
          </button>
          <VtradingPagination
            pages={Number(process.env.REACT_APP_MAX_PORTFOLIOS)}
          />

          <div
            className="Mobile__vtrading-dropdown"
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              className="TradathonRoom__button-Mobile"
              style={{
                margin: 0,
                position: "relative",
              }}
              onClick={() => setOpenDropdown(!openDropdown)}
            >
              <BsChevronDown size={14} />
              {openDropdown && (
                <div
                  className="Appbar__profile__transparent"
                  style={{ display: "block" }}
                >
                  {/* <div className="Appbar__profile__dropdown__triangle"></div> */}
                  <div
                    className="Appbar__profile__dropdown"
                    style={{ height: "120px" }}
                  >
                    <ul
                      style={{
                        listStyleType: "none",
                        paddingLeft: 0,
                        alignItems: "flexStart",
                      }}
                    >
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpenDropdown(false);
                          setVtButton("position");
                        }}
                      >
                        Position
                      </li>
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpenDropdown(false);
                          setVtButton("history");
                        }}
                      >
                        History
                      </li>
                      <li
                        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                        onClick={() => {
                          setOpenDropdown(false);
                          setVtButton("openOrder");
                        }}
                      >
                        Open Order
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </button>
          </div>
          <div
            className="Vtrading__buttons_group"
            style={{
              justifyContent: "space-between",
              justifySelf: "flex-end",
              gap: "10px",
            }}
          >
            <button
              className="Vtrading__button"
              onClick={() => setVtButton("position")}
              style={{
                background: vtButton === "position" ? "#e8bd6e" : "#fff",
                color: vtButton === "position" ? "#fff" : "#000",
              }}
            >
              Position
            </button>
            <button
              className="Vtrading__button"
              style={{
                background: vtButton === "history" ? "#e8bd6e" : "#fff",
                color: vtButton === "history" ? "#fff" : "#000",
              }}
              onClick={() => setVtButton("history")}
            >
              History
            </button>
            <button
              className="Vtrading__button"
              style={{
                background: vtButton === "openOrder" ? "#e8bd6e" : "#fff",
                color: vtButton === "openOrder" ? "#fff" : "#000",
                whiteSpace: "nowrap",
              }}
              onClick={() => setVtButton("openOrder")}
            >
              Open order
            </button>
          </div>
        </div>
        {vTradingLoading || !livePriceData ? (
          //  || !singlePortfolio
          <DummyVtradingScreen2 />
        ) : position && position.length > 0 ? (
          <VtradingScreen2 />
        ) : historyOrders && historyOrders.length > 0 ? (
          <VtradingScreen2 />
        ) : openOrders && openOrders.length > 0 ? (
          <VtradingScreen2 />
        ) : (
          <div className="Vtrading__investment__container">
            <div className="Vtrading__investment__content__container">
              <div className="VTradingScreen2__container">
                <div
                  className={
                    activePortfolio > 1
                      ? "Vtrading__next__active"
                      : "Vtrading__next"
                  }
                  onClick={() =>
                    activePortfolio > 1 &&
                    setActivePortfolioPage(activePortfolio - 1)
                  }
                >
                  <IoIosArrowBack size={30} />
                </div>
                <div
                  className={
                    activePortfolio <
                    Number(process.env.REACT_APP_MAX_PORTFOLIOS)
                      ? "Vtrading__next__active"
                      : "Vtrading__next"
                  }
                  onClick={() =>
                    activePortfolio <
                      Number(process.env.REACT_APP_MAX_PORTFOLIOS) &&
                    setActivePortfolioPage(activePortfolio + 1)
                  }
                >
                  <IoIosArrowForward size={30} />
                </div>
              </div>
              {userData.VirtualPortfolio &&
              userData.VirtualPortfolio.length < activePortfolio ? (
                <>
                  <div
                    className="Vtrading__investment__icon__container"
                    onClick={showModal}
                    style={{ cursor: "pointer" }}
                  >
                    {paymentLoading ? (
                      <div
                        className="loader1"
                        style={{
                          height: "50px",
                          width: "50px",
                          display: "inline-block",
                          border: "4px solid #fff",
                          borderTop: "4px solid #8d0792",
                          marginLeft: "5px",
                        }}
                      ></div>
                    ) : (
                      <BsFillLockFill size={60} />
                    )}
                  </div>
                  <p>
                    Pay to Unlock <br />
                    this Portfolio
                  </p>
                </>
              ) : (
                <>
                  <div
                    className="Vtrading__investment__icon__container"
                    onClick={() => history.push("/vtrading/screen")}
                    style={{ cursor: "pointer" }}
                  >
                    <HiOutlinePlusSm size={60} />
                  </div>
                  <p>
                    No Investment Done Buy <br />
                    your Coins Now
                  </p>
                </>
              )}
            </div>
          </div>
        )}
        {/* <center>
      <div className="SingleCrypto__buttons__group">
        <button className="SingleCrypto__grid__compare__button">
          Expert’s Portfolios
        </button>

        <button className="SingleCrypto__grid__moreinfo__button">
          Take Portfolio Tour
        </button>
      </div>
    </center> */}
      </div>
    </div>
  );
};
export default Vtrading;
